<template>
  <div class="card-wrap" v-if="info.url && info.pic">
    <a :href="info.url"
       target="_blank">
      <div class="img">
        <img v-lazy="picSrc"
             alt="">
        <div v-if="type=='bilibili'" class="icon-player"></div>
      </div>
      <div class="content">
        <div class="card-title">{{info.subtitle}}</div>
        <div class="bottom">
          <div class="username">
            <div class="avatar">
              <img
                 v-lazy="avatarSrc"
                 alt="">
            </div>
            <span>{{info.auth}}</span>
          </div>
          <div class="line"></div>
          <div class="user-title">{{info.title}}</div>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  props:{
    type:{
      default: ''
    },
    info:{
      default(){
        return {}
      }
    }
  },
  computed:{
    picSrc(){
       if(this.info.pic){
        return require(`../../../assets/pic/${this.type}/${this.info.pic}`)
      }
      return ''
    },
    avatarSrc(){
      if(this.info.avatar){
        return require(`../../../assets/avatar/${this.type}/${this.info.avatar}`)
      }
      return ''
    }
  }
}
</script>

<style lang="less" scoped>
.card-wrap {
  width: 346px;
  height: 325px;
  border-radius: 5px;
  overflow: hidden;
  transition: all 0.3s;
  background-color: #fff;
  margin-right: 21px;
  margin-bottom: 20px;
  cursor: pointer;
  &:hover {
    transform: translate3d(0, -2px, 0);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  }
}
.img {
  width: 100%;
  height: 0px;
  padding-top: (215/346)*100%;
  overflow: hidden;
  position: relative;
  img {
    height: 100%;
    position: absolute;
    transform: translateX(-50%);
    top: 0;
    left: 50%;
  }
  .icon-player{
    width: 37px;
    height: 31px;
    position: absolute;
    left: 14px;
    bottom: 14px;
    background: url(../../../assets/images/pc/player.png) no-repeat center center;
    background-size: 100%;
  }
}
.content {
  padding: 12px 14px;
}
.card-title {
  font-size: 16px;
  font-weight: bold;
  line-height: 22px;
  height: 44px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.bottom {
  display: flex;
  align-items: center;
  margin-top: 16px;
  font-size: 12px;
}
.username {
  display: flex;
  align-items: center;
  .avatar {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    margin-right: 5px;
    background-color: #d8d8d8;
    overflow: hidden;
    img{
      width: 100%;
      height: 100%;
    }
  }
}
.line {
  width: 1px;
  height: 9px;
  background-color: #d8d8d8;
  margin: 0 10px;
}
.user-title {
  color: #23cde1;
}
</style>